import { createTheme, PaletteColorOptions } from '@mui/material/styles';

// === Extend PaletteColor and PaletteOptions ===
declare module '@mui/material/styles' {
  interface PaletteColor {
    hero?: string;
    shades?: {
      50?: string;
      100?: string;
      200?: string;
      250?: string;
      300?: string;
      600?: string;
      800?: string;
      900?: string;
    };
    monochrome?: {
      primary?: string;
      secondary?: string;
      light?: string;
      medium?: string;
      dark?: string;
    };
    tint?: {
      t1?: string;
      t2?: string;
      t3?: string;
      t4?: string;
      t5?: string;
    };
  }

  // Note: We'll handle PaletteColorOptions via type assertion in the theme creation

  interface PaletteOptions {
    primary?: PaletteColorOptions;
    secondary?: PaletteColorOptions;
  }

  // === Add custom breakpoint "iphone" ===
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    xl: true;
    iphone: true; // ✅ now valid
  }

  // === Custom theme properties ===
  export interface Theme {
    bar: { height: string; backgroundColor: string, color?: string, fontSize?: string };
    barButtons: { maxHeight: string };
    subBarButtons: { maxHeight: string };
    secondBar: { height: string };
    iconColor: { color: string };
    container: { paddingLeft: string; paddingRight: string };
  }
  interface ThemeOptions {
    bar?: { height?: string; backgroundColor?: string, color?: string, fontSize?: string };
    barButtons?: { maxHeight?: string };
    subBarButtons?: { maxHeight?: string };
    secondBar?: { height?: string };
    iconColor?: { color?: string };
    container?: { paddingLeft?: string; paddingRight?: string };
  }
}

const theme = createTheme({
  breakpoints: {
    values: {
      iphone: 200, // ✅ now supported
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    button: { textTransform: 'none' },
    fontFamily: [
      'Inter',
      'system-ui',
      'sans-serif'
    ].join(','),
  },
  bar: { height: '50px', backgroundColor: '#ffffff', color: '#1a1a1a', fontSize: '0.75rem' },
  barButtons: { maxHeight: '30px' },
  subBarButtons: { maxHeight: '27px' },
  secondBar: { height: '44px' },
  iconColor: { color: 'black' },
  container: { paddingLeft: '10px', paddingRight: '10px' },

  palette: {
    background: { default: '#ebebeb' },
    primary: {
      light: '#FFFFFF',
      main: '#000000',
      // Neutral near-black hover for contained primary buttons. Was MUI's
      // stock navy (#002884) — never set intentionally (main is black), so it
      // leaked an off-brand dark-blue hover onto every primary button.
      dark: '#333333',
      contrastText: '#FFFFFF',
      hero: '#c58ed4',
      shades: {
        50: '#d9d9d9',
        100: '#c58ed4',
        200: '#a251b9',
        250: '#9b9b9b',
        300: '#6d337f',
        600: '#37193f',
        800: '#6c6c6c',
        900: '#000000',
      },
      monochrome: {
        primary: '#c58ed4',
        secondary: '#6d337f',
        light: '#eaeaea',
        medium: '#3d3d3d',
        dark: '#18191b',
      },
      tint: {
        t1: '#c58ed4',
        t2: '#d2abdd',
        t3: '#e2c7e8',
        t4: '#f0e3f4',
        t5: '#ffffff',
      },
    } as any, // ✅ Type assertion to bypass PaletteColorOptions restrictions
    secondary: {
      light: '#ff7961',
      main: '#cccccc',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

export default theme;